import { render } from "./Consumos.vue?vue&type=template&id=3e8f6036&scoped=true"
import script from "./Consumos.vue?vue&type=script&lang=js"
export * from "./Consumos.vue?vue&type=script&lang=js"

import "./Consumos.vue?vue&type=style&index=0&id=3e8f6036&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8f6036"]])

export default __exports__